function domReady(init) {
  document.addEventListener('DOMContentLoaded', init);
}

function find(selector) {
  return document.querySelectorAll(selector);
}

function findOne(selector) {
  return document.querySelectorAll(selector)[0];
}

function findId(selector) {
  return document.getElementById(selector);
}

function each(items, callback) {
  if (items[0]) {
    [].forEach.call(items, callback);
  } else {
    callback(items);
  }
}

function on(els, event, callback) {
  each(els, (el) => {
    if (el.addEventListener) {
      el.addEventListener(event, callback);
    }
  });
}

function inArray(value, array) {
  return [].indexOf.call(array, value) > -1;
}

function onTouchOrClick(els, callback) {
  on(els, 'click', handleTouchOrClick(callback));
  on(els, 'touchstart', handleTouchOrClick(callback));
}

function handleTouchOrClick(callback) {
  return (e) => {
    // prevent click event event, if triggering event was touchstart
    if (e.type === 'touchstart') {
      e.preventDefault();
    }

    callback(e);
  };
}

export default {
  domReady,
  find,
  findOne,
  findId,
  each,
  on,
  inArray,
  tap: onTouchOrClick,
  handleTap: handleTouchOrClick,
};



// WEBPACK FOOTER //
// ./src/js/elm.js